// v2 text-to-speech — self-contained. Same backend endpoint as v1
// (POST /api/v1/textToSpeech/synthesize), returns base64 mp3 in result.
import axiosInstance from "../../lib/utils/axiosUtil";
import { baseURL } from "../../lib/utils/constants";

export interface SynthesizeArgs {
  language: string;
  doctor: string;
  patient: string;
  room?: string;
}

export const synthesizeSpeech = async (
  args: SynthesizeArgs
): Promise<string | null> => {
  const res = await axiosInstance.post(`${baseURL}/textToSpeech/synthesize`, {
    language: args.language,
    doctor: args.doctor.toLowerCase(),
    patient: args.patient.toLowerCase(),
    ...(args.room ? { room: args.room } : {}),
  });
  return res?.data?.result ?? null; // base64-encoded mp3
};
